import React, { useEffect, useState } from "react";

import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  
  Input,
  Button,
  Spinner,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  FormGroup,
} from "reactstrap";
import { MdModeEdit, MdDelete } from "react-icons/md";
import { HiEye } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import Swal from 'sweetalert2';
import { useDispatch } from "react-redux";
import { FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";


function ReviewAndRatingList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [usersReviewAndRating, setUsersReviewandRating] = useState([]);
  const [action, setAction] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [alertLoader, setAlertLoader] = useState(false);
  const [showAlter, setShowAlter] = useState(false);
  const pageSize = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [loader, setLoader] = useState(false);
  const [ratingId, setRatingId] = useState(null);
  const [allProviderLis, setAllProviderLis] = useState([])
  const [providerId,setProviderId]=useState("")
const [userReviewDetails,setUserReviewDetails]=useState([])
  const fetchUsersReviewAndrating= async (pageNumber, query = "" ,status="") => {
    try {
      setLoader(true);
      const filterData = {
        userId:providerId,
        limit:pageSize,
        page:pageNumber,
        sortField: "createdAt",
        sortOrder: "desc",
        search: query,
        filter:"",
      };
      const getAllProvidersRatingAndReview= await ApiClient.post(
        "api/rating/getallratings",
        filterData,
        true,
        dispatch
      );
      setUsersReviewandRating(getAllProvidersRatingAndReview?.body?.ratings);
    //   setCounting(getAllProvidersRatingAndReview.data);
    setUserReviewDetails(getAllProvidersRatingAndReview?.body)

      setLoader(false);
    } catch (error) {
      toast.error(error.response.data.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  const fetchProvider =async()=>{
    try {
        setLoader(true);
        const getAllProviders= await ApiClient.get(
            "api/rating/getallproviders",
            true,
            dispatch
          );
          setAllProviderLis(getAllProviders?.body)
          setLoader(false);
    } catch (error) {
        toast.error(error.response.data.message, { autoClose: 3000 });  
        setLoader(false);
 
    }
  }

  useEffect(() => {
    if(providerId){
        fetchUsersReviewAndrating(currentPage, searchQuery,statusFilter);
    }
  }, [currentPage, searchQuery,statusFilter,providerId]);

  useEffect(() => {
   fetchProvider() 
  },[])
  

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleProvider = (e) => {
   const {value} =e.target
    setStatusFilter(value);
    setCurrentPage(1);
  };

  const handleDelete = async () => {
    if (ratingId) {
      try {
        setAlertLoader(true);
        const deleteUser = await ApiClient.put(
          `api/rating/update-rating-review-status/${ratingId}`,
          { action: "isDeleted", actionValue: "true" },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        fetchUsersReviewAndrating()
        toast.success(deleteUser.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.response.data.message, { autoClose: 3000 });
      }
    }
  };

  const handleStatus = async () => {
    if (ratingId) {
      try {
        setAlertLoader(true);
        const updateUserStatus = await ApiClient.put(
          `api/rating/update-rating-review-status/${ratingId}`,
          { action: "status", actionValue: action },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        fetchUsersReviewAndrating();
        toast.success(updateUserStatus.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.response.data.message, { autoClose: 3000 });
      }
    }
  };

  const openAlertDialog = (id, action) => {
    setRatingId(id);
    setAction(action);
    setShowAlter(true);

  };

  const getActionIcon = () => {
    return action === "delete" ? <FaExclamationTriangle /> : <FaInfoCircle />;
  };


  const handleChange = (e) => {
  setProviderId(e.target.value)
  }

  console.log(usersReviewAndRating,"usserrrr review rating")
  return (
    <>
      <div className="content">
      <div className="content-headline d-flex justify-content-between">
        <h4>Reviews & Ratings</h4>
      </div>
        <Row>
          <Col md="12">
            <Card>
            <CardHeader>
                <Row>
                  <Col md="12" className="d-flex align-items-center justify-content-between">
                    <FormGroup className="filter-dropdown d-flex align-items-center">
                      <Label className="mr-4 mb-0" style={{ fontWeight: 'bold', fontSize:"1rem"}}>Select From Dropdown</Label>
                      <Input
                        type="select"
                        id="statusFilter"
                        value={providerId}
                        onChange={handleChange}
                      >
                        <option value="" disabled selected>
                Select a category
              </option>   
              {allProviderLis.map((provider) => {
                return (
                  <option value={provider?.providerId}>
                    {provider?.fullName}
                  </option>
                );
              })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {loader && (
                  <span className="table-loader">
                    <Spinner color="primary">Loading...</Spinner>
                  </span>
                )}
                {!loader && usersReviewAndRating.length > 0 && (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Rating To</th>
                          <th>Rating From</th>
                          <th>Comment</th>
                          <th>Rating</th>
                          <th>Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {usersReviewAndRating?.map((user, index) => (
                          <tr key={user._id}>
                            <td>{user?.ratingTo?.fullName}</td>
                            <td>{user?.ratingFrom?.fullName}</td>
                            <td>{user?.comment}</td>
                            <td>{user?.stars}</td>
                            <td>
                              {user?.status && user?.status == "activated" ? (
                                <Button
                                  onClick={() =>
                                    openAlertDialog(user?._id, "deactivated")
                                  }
                                  className="common-button"
                                >
                                  Activated
                                </Button>
                              ) : (
                                <Button
                                  onClick={() =>
                                    openAlertDialog(user?._id, "activated")
                                  }
                                  className="common-button-danger"
                                >
                                  Deactivated
                                </Button>
                              )}
                            </td>
                            <td className="text-center">
                              <span
                                className="action-icon action-icon-red"
                                onClick={() => openAlertDialog(user._id,"delete")}
                              >
                                <MdDelete />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="pagination d-flex justify-content-center align-items-center">
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="common-button"
                      >
                        Previous
                      </Button>
                      <span className="mx-3">
                        Page {userReviewDetails?.page} of {userReviewDetails?.totalPages}
                 
                        <strong className="ml-3">Total records: </strong>
                        {userReviewDetails?.totalRatings}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === userReviewDetails?.totalPages}
                        className="common-button"
                      >
                        Next
                      </Button>
                    
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showAlter && (
            <Swal
              customIcon={getActionIcon()} // Use customIcon for the icon
              showCancel
              confirmBtnText={
                alertLoader ? (
                  <span>
                    Confirm <Spinner size="sm" />
                  </span>
                ) : (
                  "Confirm"
                )
              }
              confirmBtnBsStyle={`${action === "delete" ? "danger" : "info"}`}
              title="Are you sure?"
              onConfirm={() => {
                if (action === "delete") {
                  handleDelete();
                } else {
                  handleStatus();
                }
              }}
              onCancel={() => setShowAlter(false)}
              focusCancelBtn
            >
                {/* {action === 'delete' ? 'You want to verify this service provider.' : `You want to ${action} this service.`} */}
                You want to {action} this Rating.
            </Swal>
          )}
    </>
  );
}

export default ReviewAndRatingList;
